import { baseAccount } from 'wagmi/connectors';
import { extendConnector } from './utils.js';
export const createBaseAccountConnector = /*#__PURE__*/ (params) => extendConnector(baseAccount(params), 'baseAccount', 'Base Account');
//# sourceMappingURL=baseAccount.js.map